import React, { Component } from "react";
import * as Server from "../Server";
import {
  Card,
  CardBody,
  CardHeader,
  Label,
  Input,
  Row,
  Col,
  Button,
  Table,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  CustomInput,
} from "reactstrap";
import { BsPlusCircle } from "react-icons/bs";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import * as GeneralFunctions from "../GeneralFunctions";
import NotificationSystem from "react-notification-system";
import { GlobalContext } from "../components/Layout/MainLayout";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";

let user = {};

class RushParents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pages: 0,
      limit: 10,
      globalSearchData: "",
      rushUsers: [],
      rushUser: {},
      totalUsers: 0,
      pageNumbers: [],
      playerViewModal: false,
      registerPlayerModal: false,
      registerFormFieldsPlayers: [],
      wavierFormFieldsPlayers: [],
      player: {},
      clubId: "",
      SPIEvent: false,
    };
  }

  componentDidMount() {
    user = GeneralFunctions.getAuthUser();
    this.setState({ limit: this.context.limit }, () => this.getParents());
  }

  getParents = async (event) => {
    if (event) event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let page = this.state.page;
      let pageLimit = this.state.limit;
      let response = await Server.serverRequest({
        url: "rushUser/web/getUsers",
        method: "POST",
        data: {
          page,
          pageLimit,
          type: "adult",
          clubId: user.connectUserId,
          globalSearchData: this.state.globalSearchData || "",
        },
      });
      if (response) {
        if (user.connectedUser) {
          await this.getRegistrationForm(user.connectedUser);
        }
        this.setState({
          showLoader: false,
          rushUsers: response.rushUsers,
          totalUsers: response.totalUsers,
          pages: response.pages,
          SPIEvent: user.connectedUser && user.connectedUser.SPIEvent,
        });
        let pageNumbers = [];
        for (let page = 1; page <= response.pages; page++) {
          pageNumbers.push(page);
        }
        this.setState({ pageNumbers: pageNumbers });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getRegistrationForm = async (connecteduser) => {
    try {
      this.setState({ showLoader: true });
      if (connecteduser.registerForm) {
        let allFields = connecteduser.registerForm.reduce(
          (previousValue, currentValue) => {
            previousValue.push(...currentValue.fields);
            return previousValue;
          },
          []
        );
        let playerFields = allFields.filter(
          (form) =>
            form.for.value === "player" &&
            form.inputType !== "fileupload" && //remove fileuploads
            form._id !== "2e3b1830-6147-4955-a3b3-b8e3a2db3d14"
        );
        let wavierFormFieldsPlayers = allFields.filter(
          (form) => form.for.value === "player" && form.inputType === "waviers"
        );
        this.setState({
          showLoader: false,
          clubId: connecteduser._id,
          registerFormFieldsPlayers: playerFields,
          wavierFormFieldsPlayers,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateState = async (type, key, value) => {
    if (value === "on") {
      switch (type) {
        case "adult":
          value = !this.state.adult[key];
          break;
        case "player":
          value = !this.state.player[key];
          break;
        default:
          break;
      }
    }
    if (key === "phone" || key === "playerPhone") {
      if (value.length > 10) {
        return true;
      }
    }
    switch (type) {
      case "adult":
        this.setState((prevState) => ({
          adult: {
            ...prevState.adult,
            [key]: value,
          },
        }));
        break;
      case "player":
        this.setState((prevState) => ({
          player: {
            ...prevState.player,
            [key]: value,
          },
        }));
        break;
      default:
        break;
    }
  };

  onSubmit = async (event) => {
    event.preventDefault();
    try {
      let formData = new FormData();
      this.setState({ showLoader: true });
      let playerFileFields = this.state.registerFormFieldsPlayers.filter(
        (field) => field.inputType === "dropdown"
      );
      for (let index = 0; index < playerFileFields.length; index++) {
        const playerFileField = playerFileFields[index];
        if (playerFileField.required) {
          if (!this.state.player[playerFileField.keyName]) {
            throw Error(`Select the ${playerFileField.placeholder}`);
          }
        }
      }
      let playerFileUploadFields = this.state.registerFormFieldsPlayers
        .filter((field) => field.inputType === "fileupload")
        .map((field) => Object.assign(field, { for: "player" }));
      for (let index = 0; index < playerFileUploadFields.length; index++) {
        const playerFileUploadField = playerFileUploadFields[index];
        if (playerFileUploadField.required) {
          if (this.state.player[playerFileUploadField.keyName]) {
            formData.append(
              [playerFileUploadField.keyName],
              this.state.player[playerFileUploadField.keyName]
            );
          } else {
            throw Error(`Select the ${playerFileUploadField.placeholder}`);
            // let blob = this.dataURItoBlob(DefaultImage);
            // formData.append(
            //   [playerFileUploadField.keyName],
            //   blob,
            //   "defaultUser.png"
            // );
          }
        } else {
          if (this.state.player[playerFileUploadField.keyName])
            formData.append(
              [playerFileUploadField.keyName],
              this.state.player[playerFileUploadField.keyName]
            );
        }
      }
      formData.append("clubId", this.state.clubId);
      formData.append("parentId", this.state.rushUser._id);
      formData.append("player", JSON.stringify(this.state.player));
      let deleteKeys = playerFileUploadFields.map((fields) => ({
        keyName: fields.keyName,
        for: fields.for,
      }));
      if (deleteKeys && deleteKeys.length)
        formData.append("deleteKeys", JSON.stringify(deleteKeys));
      let response = await Server.serverRequest(
        {
          url: "rushUser/registerPlayer",
          method: "POST",
          data: formData,
        },
        false
      );
      if (response) {
        if (response.success) {
          if (response.user.child.length) {
            response.user.child = response.user.child.filter(
              (kid) => !kid.systemGenerated
            );
          }
          this.setState(
            {
              showLoader: false,
              player: {},
              rushUser: {},
            },
            () => this.getParents()
          );
          this.toggleRegisterPlayerModal();
          this.notificationSystem.addNotification({
            message: response.message,
            level: "success",
          });
        }
      }
    } catch (error) {
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
      this.setState({
        showLoader: false,
      });
    }
  };

  handleChange = async (type, key, event) => {
    const fileUploaded = event.target.files[0];
    switch (type) {
      case "adult":
        this.setState((prevState) => ({
          adult: {
            ...prevState.adult,
            [key]: fileUploaded,
            [`${key}FileName`]: fileUploaded.name,
          },
        }));
        break;
      case "player":
        this.setState((prevState) => ({
          player: {
            ...prevState.player,
            [key]: fileUploaded,
            [`${key}FileName`]: fileUploaded.name,
          },
        }));
        break;
      default:
        break;
    }
    event.target.value = null;
  };

  refreshPagination = (page, limit) => {
    this.setState({ page: parseInt(page, 10), limit: limit }, () => {
      this.getParents();
    });
  };

  togglePlayerViewModal = (rushUser) => {
    this.setState({
      rushUser: rushUser ? rushUser : {},
      playerViewModal: !this.state.playerViewModal,
    });
  };

  toggleRegisterPlayerModal = (rushUser) => {
    this.setState({
      rushUser: rushUser ? rushUser : {},
      registerPlayerModal: !this.state.registerPlayerModal,
    });
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page title="Parents" breadcrumbs={[{ name: "Parents", active: true }]}>
          <Card>
            <CardHeader>
              <Row>
                <Col xl={4} lg={12} md={12}>
                  <div className="d-flex">
                    <div sm={4} className="mt-2 pr-2">
                      <Label>Shown</Label>
                    </div>
                    <div sm={4}>
                      <Input
                        type="select"
                        name="pageLimit"
                        value={this.state.limit}
                        onChange={(event) => {
                          this.refreshPagination(1, event.target.value);
                          this.context.updateState({
                            limit: event.target.value,
                          });
                        }}
                      >
                        <option value={10}>10</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </Input>
                    </div>
                    <div sm={4} className="mt-2 pl-2">
                      <Label>entries</Label>
                    </div>
                  </div>
                </Col>
                <Col xl={4} lg={12} md={12}>
                  <div className="d-flex justify-content-center">
                    <div className="mt-2 pr-2">
                      <Label>
                        Showing{" "}
                        {!this.state.totalUsers
                          ? 0
                          : this.state.page * this.state.limit -
                            (this.state.limit - 1) +
                            " "}{" "}
                        to{" "}
                        {this.state.page * this.state.limit >
                        this.state.totalUsers
                          ? this.state.totalUsers
                          : this.state.page * this.state.limit}{" "}
                        of {this.state.totalUsers}
                      </Label>
                    </div>
                  </div>
                </Col>
                <Col xl={4} lg={12} md={12}>
                  <div className="d-flex justify-content-end">
                    <div sm={4} className="pr-2">
                      <Button
                        className="rounded-circle"
                        disabled={this.state.page <= 1}
                        onClick={(event) =>
                          this.refreshPagination(
                            this.state.page - 1,
                            this.state.limit
                          )
                        }
                      >
                        <MdKeyboardArrowLeft size="20px"></MdKeyboardArrowLeft>
                      </Button>
                    </div>
                    <div sm={4}>
                      <Input
                        type="select"
                        value={this.state.page}
                        name="filter"
                        onChange={(event) => {
                          this.refreshPagination(
                            event.target.value,
                            this.state.limit
                          );
                        }}
                      >
                        {this.state.pageNumbers.length !== 0 ? (
                          this.state.pageNumbers.map((pageNumber, index) => (
                            <option value={pageNumber} key={index}>
                              {pageNumber}
                            </option>
                          ))
                        ) : (
                          <option value={0}>0</option>
                        )}
                      </Input>
                    </div>
                    <div sm={4} className="pl-2">
                      <Button
                        className="rounded-circle"
                        disabled={this.state.page >= this.state.pages}
                        onClick={(event) =>
                          this.refreshPagination(
                            this.state.page + 1,
                            this.state.limit
                          )
                        }
                      >
                        <MdKeyboardArrowRight size="20px"></MdKeyboardArrowRight>
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Form onSubmit={(e) => this.getParents(e)}>
                <Row className="mb-3">
                  <Col md={4}>
                    <Input
                      type="search"
                      value={this.state.globalSearchData}
                      placeholder="Search"
                      onChange={(event) =>
                        this.setState({ globalSearchData: event.target.value })
                      }
                    />
                  </Col>
                  <Col md={4}>
                    <Button className="mt-3 mt-md-0">Search</Button>
                  </Col>
                </Row>
              </Form>
              <Row>
                <Col>
                  <Table striped hover responsive>
                    <thead>
                      <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Players</th>
                        {!this.state.SPIEvent ? <th>Add Player</th> : null}
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.rushUsers.length > 0 ? (
                        this.state.rushUsers.map((user, index) => (
                          <tr key={index}>
                            <td>{user.data.firstName}</td>
                            <td>{user.data.lastName}</td>
                            <td>{user.data.email}</td>
                            <td>{user.data.phone}</td>
                            <td>
                              <div
                                style={{ color: "#17517b", cursor: "pointer" }}
                                onClick={() => this.togglePlayerViewModal(user)}
                              >
                                View
                              </div>
                            </td>
                            {!this.state.SPIEvent ? (
                              <td>
                                <BsPlusCircle
                                  size="25px"
                                  style={{
                                    outline: "unset",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    this.toggleRegisterPlayerModal(user)
                                  }
                                />
                              </td>
                            ) : null}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No Parents found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </CardBody>
          </Card>
          {this.state.playerViewModal ? (
            <Modal
              isOpen={this.state.playerViewModal}
              toggle={(event) => this.togglePlayerViewModal()}
              className="modal-md"
            >
              <ModalHeader toggle={(event) => this.togglePlayerViewModal()}>
                Players
              </ModalHeader>
              <ModalBody>
                <Table responsive style={{ marginBottom: "0px" }}>
                  <thead>
                    <tr>
                      <th>Player Name</th>
                      <th>View</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.rushUser.child &&
                    this.state.rushUser.child.length ? (
                      this.state.rushUser.child.map((value, index) => (
                        <tr key={index}>
                          <td>{`${value.data.firstName} ${value.data.lastName}`}</td>
                          <td>
                            <div
                              style={{ color: "#17517b", cursor: "pointer" }}
                              onClick={() =>
                                this.props.history.push({
                                  pathname: "/playerDetail",
                                  state: { childId: value._id },
                                })
                              }
                            >
                              View
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="5"
                          className="text-center"
                          style={{ background: "#dee2e6" }}
                        >
                          Players not found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </ModalBody>
              <ModalFooter></ModalFooter>
            </Modal>
          ) : null}
          {this.state.registerPlayerModal ? (
            <Modal
              isOpen={this.state.registerPlayerModal}
              toggle={(event) => this.toggleRegisterPlayerModal()}
              className="modal-md"
            >
              <ModalHeader toggle={() => this.toggleRegisterPlayerModal()}>
                Register Player :
              </ModalHeader>
              <ModalBody>
                <Form className="form" onSubmit={this.onSubmit}>
                  {this.state.registerFormFieldsPlayers.map(
                    (registerFormField, index) => (
                      <Col key={index}>
                        <FormGroup>
                          {registerFormField.inputType === "text" && (
                            <>
                              <Label>
                                {registerFormField.placeholder}
                                {registerFormField.required && (
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    *
                                  </span>
                                )}
                              </Label>
                              <Input
                                disabled={this.state.playerDisabledFields}
                                id={index}
                                name={registerFormField.name}
                                type="text"
                                value={
                                  this.state.player[
                                    registerFormField.keyName
                                  ] || ""
                                }
                                onChange={(event) =>
                                  this.updateState(
                                    "player",
                                    registerFormField.keyName,
                                    event.target.value
                                  )
                                }
                                placeholder={registerFormField.placeholder}
                                required={registerFormField.required}
                              />
                            </>
                          )}
                          {registerFormField.inputType === "number" && (
                            <>
                              <Label>
                                {registerFormField.placeholder}
                                {registerFormField.required && (
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    *
                                  </span>
                                )}
                              </Label>
                              <Input
                                disabled={this.state.playerDisabledFields}
                                id={index}
                                name={registerFormField.name}
                                type="number"
                                value={
                                  this.state.player[
                                    registerFormField.keyName
                                  ] || ""
                                }
                                onChange={(event) =>
                                  event.target.value > -1 &&
                                  this.updateState(
                                    "player",
                                    registerFormField.keyName,
                                    event.target.value
                                  )
                                }
                                placeholder={registerFormField.placeholder}
                                required={registerFormField.required}
                              />
                            </>
                          )}
                          {registerFormField.inputType === "datepicker" && (
                            <>
                              <Label>
                                {registerFormField.placeholder}
                                {registerFormField.required && (
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    *
                                  </span>
                                )}
                              </Label>
                              <Input
                                disabled={this.state.playerDisabledFields}
                                id={index}
                                name={registerFormField.name}
                                type="date"
                                value={
                                  this.state.player[
                                    registerFormField.keyName
                                  ] || ""
                                }
                                onChange={(event) =>
                                  this.updateState(
                                    "player",
                                    registerFormField.keyName,
                                    event.target.value
                                  )
                                }
                                placeholder={registerFormField.placeholder}
                                required={registerFormField.required}
                              />
                            </>
                          )}
                          {registerFormField.inputType === "dropdown" && (
                            <>
                              <Label>
                                {registerFormField.placeholder}
                                {registerFormField.required && (
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    *
                                  </span>
                                )}
                              </Label>
                              <Input
                                disabled={this.state.playerDisabledFields}
                                type="select"
                                name={registerFormField.name}
                                value={
                                  this.state.player[
                                    registerFormField.keyName
                                  ] || "default"
                                }
                                required={registerFormField.required}
                                onChange={(event) =>
                                  this.updateState(
                                    "player",
                                    registerFormField.keyName,
                                    event.target.value
                                  )
                                }
                              >
                                <option value="default" disabled>
                                  Select the value
                                </option>
                                {registerFormField.values.map(
                                  (value, index) => (
                                    <option key={index} value={value}>
                                      {value}
                                    </option>
                                  )
                                )}
                              </Input>
                            </>
                          )}
                          {registerFormField.inputType === "fileupload" && (
                            <>
                              <Label>
                                {registerFormField.placeholder}
                                {registerFormField.required && (
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    *
                                  </span>
                                )}
                              </Label>
                              <div>
                                <Label htmlFor={registerFormField._id}>
                                  <span className="btn btn-secondary">
                                    Select File
                                  </span>
                                  <span style={{ marginLeft: "5px" }}>
                                    {
                                      this.state.player[
                                        `${registerFormField.keyName}FileName`
                                      ]
                                    }
                                  </span>
                                </Label>
                                <input
                                  style={{ display: "none" }}
                                  id={registerFormField._id}
                                  type="file"
                                  onChange={(event) =>
                                    this.handleChange(
                                      "player",
                                      registerFormField.keyName,
                                      event
                                    )
                                  }
                                />
                              </div>
                            </>
                          )}
                        </FormGroup>
                      </Col>
                    )
                  )}
                  {this.state.wavierFormFieldsPlayers.length ? (
                    <>
                      <Col
                        style={{
                          textAlign: "center",
                          padding: "10px 0px",
                          borderTop: "3px solid #e4e5e6",
                        }}
                      >
                        <h3>Waviers For Players</h3>
                      </Col>
                      {this.state.wavierFormFieldsPlayers.map(
                        (wavierFormField, index) => (
                          <Col key={index}>
                            <FormGroup>
                              {wavierFormField.inputType === "waviers" && (
                                <>
                                  <div className="d-flex">
                                    <CustomInput
                                      type="checkbox"
                                      id={wavierFormField._id}
                                      label={wavierFormField.placeholder}
                                      required={wavierFormField.required}
                                      checked={
                                        this.state.player[
                                          wavierFormField.keyName
                                        ] || false
                                      }
                                      onChange={(event) =>
                                        this.updateState(
                                          "player",
                                          wavierFormField.keyName,
                                          event.target.value
                                        )
                                      }
                                    />
                                    {wavierFormField.required && (
                                      <span
                                        style={{
                                          color: "red",
                                          marginLeft: "5px",
                                        }}
                                      >
                                        *
                                      </span>
                                    )}
                                  </div>
                                  <Input
                                    id={index}
                                    type="textarea"
                                    disabled
                                    style={{ height: "160px" }}
                                    value={wavierFormField.value}
                                  />
                                </>
                              )}
                            </FormGroup>
                          </Col>
                        )
                      )}
                    </>
                  ) : null}
                  <Col
                    style={{
                      textAlign: "end",
                      padding: "10px 0px",
                      borderTop: "3px solid #e4e5e6",
                    }}
                  >
                    <FormGroup>
                      <Button
                        className="mr-3"
                        color="secondary"
                        onClick={() => this.toggleRegisterPlayerModal()}
                      >
                        Cancel
                      </Button>
                      <Button type="submit" color="primary" onClick={() => {}}>
                        Save
                      </Button>
                    </FormGroup>
                  </Col>
                </Form>
              </ModalBody>
              {/* <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={() => this.toggleRegisterPlayerModal()}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        color="primary"
                        onClick={() => {
                          this.toggleRegisterPlayerModal();
                        }}
                      >
                        Save
                      </Button>
                    </ModalFooter> */}
            </Modal>
          ) : null}
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
RushParents.contextType = GlobalContext;
export default RushParents;
